module.exports = __webpack_public_path__ + "img/dashboard.3d612424.svg";